<template>
	<div class="mm-sidebar  sidebar-default ">
		<div class="mm-sidebar-logo d-flex align-items-center justify-content-between">
			<router-link :to="{ name: 'layout.dashboard1' }" class="header-logo">
				<img :src="sidelogo" class="img-fluid rounded-normal" alt="logo" />
			</router-link>
			<div class="side-menu-bt-sidebar" @click="miniSidebar">
				<i class="las la-bars wrapper-menu"></i>
			</div>
		</div>
		<div class="data-scrollbar" data-scroll="1" id="sidebar-scrollbar">
			<nav class="mm-sidebar-menu">
				<ul id="mm-sidebar-toggle" class="side-menu">
					<li :class="checkActive('layout.dashboard1') ? 'active' : ''">
						<router-link :to="{ name: 'layout.dashboard1' }" class="svg-icon">
							<i class="fas fa-tachometer-alt"></i>
							<span class="">Dashboard</span>
						</router-link>
					</li>
					<!--- users starts ----->
					<li :class="checkActive(users) ? 'active' : ''">
						<a v-b-toggle.users class=" svg-icon">
							<i class="fas fa-users"></i>
							<span class="ml-2">Users</span>
							<i class="las la-angle-right mm-arrow-right arrow-active"></i>
							<i class="las la-angle-down mm-arrow-right arrow-hover"></i>
						</a>
						<b-collapse tag="ul" @shown="showCollapse('users')" @hide="hideCollapse" id="users" class="submenu " :visible="checkActive(users)" accordion="my-accordion">
							<li :class="checkActive('users.add') ? 'active' : ''">
								<router-link :to="{ name: 'users.add' }" class="svg-icon">
									<i class="fas fa-user-plus"></i>
                           <span class="">Add User</span>
								</router-link>
							</li>
							<li :class="checkActive('users.view') ? 'active' : ''">
								<!-- <router-link :to="{ name: 'users.view' }" class="svg-icon">
									<i class="fas fa-user-friends"></i>
									<span class="">View Users</span>
								</router-link> -->

								<a href="#" class="svg-icon" @click.prevent="clearBackURL('users.view')">
									<i class="fas fa-user-friends"></i>
									<span class="">View Users</span>
								</a>

							</li>

							<li :class="checkActive('users.deleted') ? 'active' : ''">			
								<a href="#" class="svg-icon" @click.prevent="clearBackURL('users.deleted')">
									<i class="fas fa-user-friends"></i>
									<span class="">Deleted Users</span>
								</a>
							</li>

							<li :class="checkActive('users.disabled') ? 'active' : ''">			
								<a href="#" class="svg-icon" @click.prevent="clearBackURL('users.disabled')">
									<i class="fas fa-user-friends"></i>
									<span class="">Disabled Users</span>
								</a>
							</li>

						</b-collapse>
					</li>
					<!--- users ends ----->
					<li :class="checkActive('layout.brands') ? 'active' : ''">
						<router-link :to="{ name: 'layout.brands' }" class="svg-icon">
							<i class="fas fa-square"></i>
                     <span class="">Brands</span>
						</router-link>
					</li>
					<li :class="checkActive('layout.models') ? 'active' : ''">
						<router-link :to="{ name: 'layout.models' }" class="svg-icon">
							<i class="fas fa-layer-group"></i>
                     <span class="">Models</span>
						</router-link>
					</li>
					
				<!--- sliders starts ----->
            <li :class="checkActive(sliders) ? 'active' : ''">
               <a v-b-toggle.sliders class=" svg-icon"> 
                  <i class="fas fa-sliders-h"></i>
                  <span class="ml-2">Sliders</span> 
                  <i class="las la-angle-right mm-arrow-right arrow-active"></i> 
                  <i class="las la-angle-down mm-arrow-right arrow-hover"></i> 
               </a>
               <b-collapse tag="ul" @shown="showCollapse('sliders')" @hide="hideCollapse" id="sliders" class="submenu "  :visible="checkActive(sliders)" accordion="my-accordion">
                  <li :class="checkActive('sliders.groups.add') ? 'active' : ''">
                     <router-link :to="{name: 'sliders.groups.add'}" class="svg-icon"> 
                        <i class="far fa-object-group"></i>
                        <span class="">Add Group</span> 
                     </router-link>
                  </li>
                  <li :class="checkActive('sliders.groups.view') ? 'active' : ''">
                     <router-link :to="{name: 'sliders.groups.view'}" class="svg-icon">
                        <i class="fas fa-object-ungroup"></i>
                        <span class="">Groups</span> 
                     </router-link>
                  </li>

                  <li :class="checkActive('sliders.general') ? 'active' : ''">
                     <!-- <router-link :to="{name: 'sliders.general'}" class="svg-icon">
                        <i class="far fa-images"></i>
                        <span class="">General Sliders</span> 
                     </router-link> -->

                     <a href="#" class="svg-icon" @click.prevent="clearBackURL('sliders.general')">
                        <i class="far fa-images"></i>
                        <span class="">General Sliders</span> 
                     </a>
                  </li>

                  <li :class="checkActive('sliders.location') ? 'active' : ''">
                     <!-- <router-link :to="{name: 'sliders.location'}" class="svg-icon">
                        <i class="fas fa-map-marked-alt"></i>
                        <span class="">Location Sliders</span> 
                     </router-link> -->

                     <a href="#" class="svg-icon" @click.prevent="clearBackURL('sliders.location')">
                        <i class="fas fa-map-marked-alt"></i>
                        <span class="">Location Sliders</span> 
                     </a>
                  </li>
                                  
               </b-collapse>
            </li>
            <!--- sliders ends ----->
            
					<li :class="checkActive('layout.categories') ? 'active' : ''">
						<router-link :to="{ name: 'layout.categories' }" class="svg-icon">
							<i class="fas fa-list-alt"></i>
                     <span class="">Categories</span>
						</router-link>
					</li>

				<!--- attributes starts ----->
            <li :class="checkActive(attributes) ? 'active' : ''">
               <a v-b-toggle.attributes class=" svg-icon"> 
                  <i class="fas fa-tasks"></i>
                  <span class="ml-2">Attributes</span> 
                  <i class="las la-angle-right mm-arrow-right arrow-active"></i> 
                  <i class="las la-angle-down mm-arrow-right arrow-hover"></i> 
               </a>
               <b-collapse tag="ul" @shown="showCollapse('attributes')" @hide="hideCollapse" id="attributes" class="submenu "  :visible="checkActive(attributes)" accordion="my-accordion">
                  <li :class="checkActive('attributes.add') ? 'active' : ''">
                     <router-link :to="{name: 'attributes.add'}" class="svg-icon"> 
                        <i class="far fa-calendar-plus"></i>
                        <span class="">Add Attribute</span> 
                     </router-link>
                  </li>
                  <li :class="checkActive('attributes.view') ? 'active' : ''">
                     <router-link :to="{name: 'attributes.view'}" class="svg-icon">
                        <i class="fas fa-calendar-alt"></i>
                        <span class="">View Attributes</span> 
                     </router-link>
                  </li>
                                  
               </b-collapse>
            </li>
            <!--- attributes ends ----->

            <!--- vehicles starts ----->
            <li :class="checkActive(vehicles) ? 'active' : ''">
               <a v-b-toggle.vehicles class=" svg-icon"> 
                  <i class="fas fa-truck"></i>
                  <span class="ml-2">Vehicles</span> 
                  <i class="las la-angle-right mm-arrow-right arrow-active"></i> 
                  <i class="las la-angle-down mm-arrow-right arrow-hover"></i> 
               </a>
               <b-collapse tag="ul" @shown="showCollapse('vehicles')" @hide="hideCollapse" id="vehicles" class="submenu "  :visible="checkActive(vehicles)" accordion="my-accordion">
                  <li :class="checkActive('vehicles.add') ? 'active' : ''">
                     <router-link :to="{name: 'vehicles.add'}" class="svg-icon"> 
                        <i class="fas fa-ambulance"></i>
                        <span class="">Add Vehicle</span> 
                     </router-link>
                  </li>
                  <li :class="checkActive('vehicles.view') ? 'active' : ''">
                     <!-- <router-link :to="{name: 'vehicles.view'}" class="svg-icon">
                        <i class="fas fa-shuttle-van"></i>
                        <span class="">View Vehicles</span> 
                     </router-link> -->

                     <a class="svg-icon" @click.prevent="clearBackURL('vehicles.view')">
                        <i class="fas fa-shuttle-van"></i>
                        <span class="">Existing Vehicles</span> 
                     </a>
                  </li>

                  <li :class="checkActive('vehicles.sold') ? 'active' : ''">                    
                    	<a class="svg-icon" @click.prevent="clearBackURL('vehicles.sold')">
                        <i class="fas fa-shuttle-van"></i>
                        <span class="">Sold Vehicles</span> 
                     </a>
                  </li>
                                  
               </b-collapse>
            </li>
            <!--- vehicles ends ----->

            <!--- accessories starts ----->
            <li :class="checkActive(accessories) ? 'active' : ''">
               <a v-b-toggle.accessories class=" svg-icon"> 
                  <i class="fas fa-tools"></i>
                  <span class="ml-2">Accessories & <br>Spare Parts</span> 
                  <i class="las la-angle-right mm-arrow-right arrow-active"></i> 
                  <i class="las la-angle-down mm-arrow-right arrow-hover"></i> 
               </a>
               <b-collapse tag="ul" @shown="showCollapse('accessories')" @hide="hideCollapse" id="accessories" class="submenu "  :visible="checkActive(accessories)" accordion="my-accordion">
                  <li :class="checkActive('accessories.add') ? 'active' : ''">
                     <router-link :to="{name: 'accessories.add'}" class="svg-icon"> 
                        <i class="fas fa-wrench"></i>
                        <span class="">Add Accessory/ <br>Spare Part</span> 
                     </router-link>
                  </li>
                  <li :class="checkActive('accessories.view') ? 'active' : ''">
                     <!-- <router-link :to="{name: 'accessories.view'}" class="svg-icon">
                        <i class="fas fa-tools"></i>
                        <span class="">View Accessories & <br>Spare Parts</span> 
                     </router-link> -->

                     <a class="svg-icon" @click.prevent="clearBackURL('accessories.view')">
                        <i class="fas fa-tools"></i>
                        <span class="">Existing Accessories & <br>Spare Parts</span> 
                     </a>
                  </li>

                  <li :class="checkActive('accessories.sold') ? 'active' : ''">                    
                     <a class="svg-icon" @click.prevent="clearBackURL('accessories.sold')">
                        <i class="fas fa-tools"></i>
                        <span class="">Sold Accessories & <br>Spare Parts</span> 
                     </a>
                  </li>
                                  
               </b-collapse>
            </li>
            <!--- accessories ends ----->

            <!--- reports starts ----->
            <li :class="checkActive(reports) ? 'active' : ''">
               <a v-b-toggle.reports class=" svg-icon"> 
                  <i class="fas fa-file-alt"></i>
                  <span class="ml-2">Reports</span> 
                  <i class="las la-angle-right mm-arrow-right arrow-active"></i> 
                  <i class="las la-angle-down mm-arrow-right arrow-hover"></i> 
               </a>
               <b-collapse tag="ul" @shown="showCollapse('reports')" @hide="hideCollapse" id="reports" class="submenu "  :visible="checkActive(reports)" accordion="my-accordion">
                  <li :class="checkActive('reports.customers') ? 'active' : ''">
                     <router-link :to="{name: 'reports.customers'}" class="svg-icon"> 
                        <i class="far fa-id-badge"></i>
                        <span class="">Customers</span> 
                     </router-link>
                  </li>
                  <li :class="checkActive('reports.vehicles') ? 'active' : ''">
                     <router-link :to="{name: 'reports.vehicles'}" class="svg-icon" >
                        <i class="fas fa-truck-moving"></i>
                        <span class="">Vehicles</span> 
                     </router-link>
                  </li>

                  <li :class="checkActive('reports.accessories') ? 'active' : ''">
                     <router-link :to="{name: 'reports.accessories'}" class="svg-icon">
                        <i class="fas fa-tools"></i>
                        <span class="">Accessories</span> 
                     </router-link>
                  </li>
                                  
               </b-collapse>
            </li>
            <!--- reports ends ----->

					<li :class="checkActive('layout.notifications') ? 'active' : ''">
						<router-link :to="{ name: 'layout.notifications' }" class="svg-icon">
							<i class="far fa-bell"></i>
                     <span class="">Notifications</span>
						</router-link>
					</li>
					<li :class="checkActive('ads.reported_problems') ? 'active' : ''">
						<!-- <router-link :to="{ name: 'ads.reported_problems' }" class="svg-icon">
							<i class="far fa-bell"></i>
                     <span class="">Reported Problems</span>
						</router-link> -->
						<a href="#" class="svg-icon" @click.prevent="clearBackURL('ads.reported_problems')">
							<i class="far fa-bell"></i>
                     <span class="">Reported Problems</span>
						</a>
					</li>
					<li :class="checkActive('layout.settings') ? 'active' : ''">
						<router-link :to="{ name: 'layout.settings' }" class="svg-icon">
							<i class="fas fa-cogs"></i>
                     <span class="">Settings</span>
						</router-link>
					</li>
				</ul>
			</nav>
			<div id="sidebar-bottom" class="position-relative sidebar-bottom">
				<div class="card bg-primary rounded">
					<div class="card-body">
						<div class="sidebarbottom-content">
							<div class="image">
								<img src="@/assets/images/layouts/layout-1/side-bkg.png" class="img-fluid" alt="side-bkg" />
							</div>
							<h5 class="mb-3 text-white mt-3">Did you Know ?</h5>
							<p class="mb-0 text-white">
								1 billion cars are currently in use around the world
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="pt-5 pb-2"></div>
		</div>
	</div>
</template>
<script>
	import { mapGetters } from "vuex";
	import { core } from "@/config/pluginInit";
	export default {
		name: "SidebarStyle",
		props: {
			items: Array,
		},
		data() {
			return {
				homeurl: "",
				users: ["users.add", "users.view", "users.edit", "users.show", "users.followers", "users.following", "users.deleted", "users.disabled"],
				attributes:['attributes.add', 'attributes.view', 'attributes.show'],
				vehicles:['vehicles.view', 'vehicles.show', 'vehicles.add', 'vehicles.edit', 'vehicles.sold'],
            accessories:['accessories.view', 'accessories.show', 'accessories.add', 'accessories.edit', 'accessories.sold'],
				dashboards: ["layout.dashboard1"],
				sliders: ['sliders.groups.add', 'sliders.groups.view', 'sliders.groups.edit', 'sliders.general', 'sliders.location'],
            reports: ['reports.customers', 'reports.vehicles'],
				auth: ["auth.login"],
				error: ["error.404", "error.500"],
				pages: [],
			};
		},
		mounted() {
			core.SmoothScrollbar();
		},
		destroyed() {
			core.SmoothScrollbar();
		},
		computed: {
			...mapGetters({
				logo: "darklogo",
				sidelogo: "logo",
			}),
		},
		methods: {
			checkActive(route) {
				if (this.$route.name == route) {
					return true;
				}
				if (route.includes(this.$route.name)) {
					return true;
				}
			},
			miniSidebar() {
				core.triggerSet();
			},
			showCollapse(collapseId) {
				document
					.getElementById(collapseId)
					.closest("li")
					.classList.add("active");
			},
			hideCollapse() {
				const list = document.querySelector(".mm-sidebar-menu").querySelectorAll(".submenu");
				Array.from(list, (elem) => {
					if (elem.closest(".active") !== null && elem.closest(".active") !== undefined) {
						elem.closest(".active").classList.remove("active");
					}
				});
			},

			clearBackURL(goto_path) {
				if(localStorage.back_url) {
					localStorage.removeItem('back_url');
				}
				this.$router.push({ name: goto_path }); 
			},
		},
	};
</script>
